export const PROVIDER_BENEFIT_FILTER_OPTIONS = [
  {
    value: "weekdayVisit",
    label: "평일 방문시 혜택",
    legacyLabels: ["평일 방문시 추가 혜택 제공", "평일 방문 혜택"],
  },
  {
    value: "contractGift",
    label: "계약시 사은품 제공",
    legacyLabels: [],
  },
];

const getFilterBenefitValue = (benefit) => {
  const normalized = typeof benefit === "string" ? benefit.trim() : "";
  if (!normalized) return "";

  const option = PROVIDER_BENEFIT_FILTER_OPTIONS.find(
    ({ value, label, legacyLabels }) =>
      value === normalized ||
      label === normalized ||
      legacyLabels.includes(normalized)
  );

  return option ? option.value : "";
};

export const splitProviderBenefits = (benefits) => {
  const filterBenefits = [];
  const consultationBenefits = [];

  (Array.isArray(benefits) ? benefits : []).forEach((benefit) => {
    const normalized = typeof benefit === "string" ? benefit.trim() : "";
    if (!normalized) return;

    const filterValue = getFilterBenefitValue(normalized);
    if (filterValue) {
      if (!filterBenefits.includes(filterValue)) {
        filterBenefits.push(filterValue);
      }
      return;
    }

    consultationBenefits.push(normalized);
  });

  return { filterBenefits, consultationBenefits };
};

export const mergeProviderBenefits = (filterBenefits, consultationBenefits) => {
  const combined = [
    ...(Array.isArray(filterBenefits) ? filterBenefits : []),
    ...(Array.isArray(consultationBenefits) ? consultationBenefits : []),
  ];
  const split = splitProviderBenefits(combined);

  return [...split.filterBenefits, ...split.consultationBenefits];
};
